import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  updateConfig,
  getDeliveryReissueListData,
} from "../../../store/slices/Delivery/deliverySlice";
// import { startTimerReissue } from "../api"; // Timer feature disabled
import { toast } from "react-toastify";
// import { getDeliveryCertificate } from "./api";

const useDeliveryReissue = () => {
  const deliveryState = useSelector((state) => state.delivery);
  const deliveryReissueData = deliveryState.deliverySectionReissueData;
  const [showDetail, setShowDetail] = useState(false);
  const [activeCard, setActiveCard] = useState({ id: "", key: "" });
  const [pendingPage, setPendingPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [gliNumber, setGliNumber] = useState("");
  const [clickedCardId, setClickedCardId] = useState(null);
  // const [certificateListData, setCertificateList] = useState();
  const dispatch = useDispatch();
  const slipRef = useRef(null);
  const chellanRef = useRef(null);
  const slug = sessionStorage?.getItem("slug");

  useEffect(() => {
    let params = {
      page: pendingPage,
      // per_page: deliveryState.currentPageSize,
      // search: deliveryState.search,
      process_slug: slug,
    };
    dispatch(getDeliveryReissueListData(params));

    // eslint-disable-next-line
  }, [pendingPage, deliveryState.currentPageSize]);

  const handleSearchInput = (e) => {
    const searchValue = e.target.value;

    dispatch(updateConfig((state) => (state.searchReissue = searchValue)));
  };

  const handleSearch = () => {
    const searchValue = deliveryState?.searchReissue;

    dispatch(
      updateConfig((state) => {
        state.deliverySectionReissueData.Pending = [];
      })
    );
    let params = {
      page: 1,
      per_page: deliveryState.currentPageSize,
      search: searchValue,
      process_slug: slug,
    };
    dispatch(getDeliveryReissueListData(params));
  };

  // Timer feature disabled
  // const startTimerDelivery = (item) => {
  //      setClickedCardId(item?._id);
  //   if (!item?._id || clickedCardId === item._id) {
  //     return;
  //   }
  //   let body = {
  //     receipt_id: item?._id,
  //     process_slug: slug,
  //     order_type:3,
  //   };
  //   startTimerReissue(body).then((response) => {
  //
  //     if (response?.data?.status_code === 200) {
  //       toast.success("Timer Started");
  //
  //     } else {
  //       toast.error("Can't Start Timer");
  //     }
  //   });
  // };

  const handleChange = (item, key, index) => {
    setActiveCard({ id: item?._id, key: key });
    dispatch(
      updateConfig((state) => {
        state.selectedReissueCardId = item?._id;
      })
    );
    setGliNumber(item?.gli_number);
    setActiveCard({ id: item?._id, key: "Pending" });
    if (key === "Pending") {
      setShowDetail(true);
      // startTimerDelivery(item); // Timer feature disabled
      // getDeliveryCertificate(item?._id, slug).then((response) => {
      //   const certificateList = response?.data;
      //   setCertificateList(certificateList);
      // });
    } else {
      setShowDetail(false);
      dispatch(
        updateConfig((state) => {
          state.receipt_id = item?._id;
        })
      );
    }
  };
  const handleLoadMore = (mouseHover) => {
    if (
      mouseHover === "Pending" &&
      deliveryReissueData?.Pending?.length !== deliveryState?.total?.Pending
    ) {
      setPendingPage(pendingPage + 1);
    }
  };

  return {
    gliNumber,
    showDetail,
    isLoading,
    activeCard,
    totalLength: {
      Pending: deliveryState.total.Pending,
    },
    apiStatus: {
      Pending: deliveryState.deliveryReissueSectionDataStatus,
    },
    deliveryReissueData,
    // certificateListData,
    handleSearch,
    handleSearchInput,
    setIsLoading,
    handleLoadMore,
    handleChange,
    // setCertificateList,
    slipRef,
    chellanRef,
  };
};

export default useDeliveryReissue;
